import Storage from "@/uitls/Storage";
import Forge from "node-forge";
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-cn' // +
const th = process.env.VUE_APP_Language as string;
if (th == 'id') {
  dayjs.locale('id') // + 
  dayjs.extend(relativeTime)
} else {
  dayjs.locale('zh-cn') // +
  dayjs.extend(relativeTime)
}



import Long from "long";
import { nativeToNewWeb } from "./native";
import i18n from "@/i18n";
const { t } = i18n.global;

export function createChatKey(myuid: number, tauid: number) {
  if (myuid < tauid) {
    return Long.fromValue(myuid * Math.pow(2, 32)).add(Long.fromValue(tauid));
  } else {
    return Long.fromValue(myuid).add(Long.fromValue(tauid * Math.pow(2, 32)));
  }
}

export function YMPush(page, event) {
  window.YMPush('_trackEvent', page, event);
}

export function fbqEvent(event, page, data = {}) {
  if (window.fbq) {
    window.fbq(event, page, data);
  }
}

export function ttqEvent(eventName, data = {}) {
  if (window.ttq) {
    window.ttq.track(eventName, data);
  }
}

export function googleEvent(event, page, data = null) {
  if (window.gtag) {
    window.gtag(event, page, data);
  }
}

export function scqEvent(event) {
  if (window.scq) {
    window.scq.trigger(event)
  }
}

//通用方法去直播间
export function uitlsToLiveRoom(data, router) {
  console.log('live data', data);

  if ((data.room_id && data.room_id != "") || data.host && (data.host[0] && data.host[0].room_id && data.host[0].room_id != "")) {
    //有主播的
    nativeToNewWeb(router, `/player?id=${data.room_id || data.host[0].room_id}&liveType=${data.live_type || 1}`)
  } else if (data.nami && data.nami.length > 0) {
    // console.log('1');
    //源
    nativeToNewWeb(router, `/player?matchType=${data.type_id}&id=${data.id}&liveType=${data.live_type}&url=1`)
  } else if (data.id && data.id != "" && data.type_id) {
    //没源的
    nativeToNewWeb(router, `/player?matchType=${data.type_id}&id=${data.id}&liveType=${data.live_type}`)
    // nativeToNewWeb(router, `/player?matchType=${data.type_id}&id=${data.id}&url=1`)
  } else if (
    data.live_id &&
    data.match_type &&
    data.live_id != "" &&
    data.live_type == 4
  ) {
    // 回放源
    nativeToNewWeb(router, `/player?matchType=${data.match_type}&id=${data.live_id}&liveType=${data.live_type}&url=1`)
  } else if (
    data.match_id &&
    data.match_type &&
    data.match_id != "" &&
    data.live_url &&
    data.live_url != ""
  ) {
    //清源
    nativeToNewWeb(router, `/player?matchType=${data.match_type}&id=${data.match_id}&liveType=${data.live_type}&url=1`)
  } else if (
    data.match_id &&
    data.match_type &&
    data.match_id != "" &&
    !data.live_url
  ) {
    //没源的
    nativeToNewWeb(router, `/player?matchType=${data.match_type}&id=${data.match_id}&liveType=${data.live_type}`)

  } else {
    //mp4
    nativeToNewWeb(router, `/player?heat=${data.id}&url=2&title=${data.room_title}&liveType=${data.live_type}`)
  }

  window.$apiNet.statisticsPost({ action_id: 1 });
}


//格式化时间
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function formatDateTime(time = 0, format = "YYYY-MM-DD HH:mm:ss") {

  if (time < 100000000000) {
    time = time * 1000
  }
  return dayjs(time).format(format);
}
export function matchListTime(time = 0, format = "HH:mm") {
  if (time < 100000000000) {
    time = time * 1000
  }
  return dayjs(time).format(format);
}

//日期转时间戳
export function dayToUnix(str) {
  const num = dayjs(str).unix()
  return num
}

// 2022-07-18 (星期三)，这样的格式
export function matchListDay(time = 0, t, format = "YYYY-MM-DD",) {

  if (time < 100000000000) {
    time = time * 1000
  }
  const day = dayjs(time).get('day');
  let daystr = ""

  switch (day) {
    case 0:
      daystr = t('tips.sunday')
      break;
    case 1:
      daystr = t('tips.monday')
      break;
    case 2:
      daystr = t('tips.tuesday')
      break;
    case 3:
      daystr = t('tips.wednesday')
      break;
    case 4:
      daystr = t('tips.thursday')
      break;
    case 5:
      daystr = t('tips.friday')
      break;
    case 6:
      daystr = t('tips.saturday')
      break;
    default:
      daystr = ""
      break;
  }
  if (formatDate(Date.now()) == formatDate(time)) {
    // const { t } = useI18n()
    daystr = t('match.nowDay')
    // daystr = "今天"
  }

  const th = process.env.VUE_APP_Language as string;
  if (th == "th") {
    return `${dayjs(time).format(format)}`;
  }


  return `${dayjs(time).format(format)} (${daystr})`;
}
export function IMformatDate(time = 0) {
  if (time < 100000000000) {
    time = time * 1000
  }
  //如果时间超过一天，用北京时间
  let now = new Date().getTime()
  if ((now - time) > (60000 * 60 * 24)) {
    return dayjs(time).format("YYYY-MM-DD");
  }
  return dayjs(time).fromNow();
}

export function formatDate(date = 0, format = "YYYY-MM-DD") {
  return formatDateTime(date, format);
}
//md5
export const md5 = (str: string) => {
  const md = Forge.md.md5.create();
  md.update(str);
  return md.digest().toHex();
};

//复制字符串
export const copy = (str: string) => {
  const oInput = document.createElement("input");
  oInput.value = str;
  document.body.appendChild(oInput);
  oInput.select();
  document.execCommand("Copy"); // 执行浏览器复制命令
  oInput.remove();
  return;
};

//获取设备id
export function deviceid(variable: string) {
  let uniqueid;
  if (window.location.search && window.location.search != "") {
    const query = window.location.search.substring(1);

    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split("=");
      if (pair[0] == variable) {
        uniqueid = pair[1];
      }
    }
  }
  if (window.location.hash && window.location.hash != "") {
    const query = window.location.hash.substring(1);

    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split("=");
      if (pair[0] == variable) {
        uniqueid = pair[1];
      }
    }
  }
  if (
    uniqueid == null ||
    uniqueid == undefined ||
    uniqueid == "" ||
    uniqueid.length < 3
  ) {
    uniqueid = Storage.get("DEVICE_ID");
    if (
      uniqueid == null ||
      uniqueid == undefined ||
      uniqueid == "" ||
      uniqueid.length < 3
    ) {
      const timestamp = Date.parse(Date());
      const randNum1 = randomTo(100000000, 999999999);
      const randNum2 = randomTo(100000000, 999999999);
      const randNum3 = randomTo(100000000, 999999999);
      uniqueid = md5(randNum1 + "" + randNum2 + "" + randNum3 + "" + timestamp);
    }
    Storage.set("DEVICE_ID", uniqueid);
  }
  return uniqueid;
}

const randomTo = (from: any, to: any) => {
  if (from == to) return from;
  const rd = Math.round(Math.random() * 10);
  return from + (rd % (to - from));
};

export function getQueryVariable(variable) {
  if (window.location.search && window.location.search != "") {
    var query = window.location.search.substring(1);
    if (query.indexOf("?") != -1) {
      query = query.substr(query.indexOf("?") + 1);
    }

    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
  }
  if (window.location.hash && window.location.hash != "") {
    var query = window.location.hash.substring(1);
    if (query.indexOf("?") != -1) {
      query = query.substr(query.indexOf("?") + 1);
    }

    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
  }
  return null;
}

export function addQueryParams(url, params) {
  // 构建查询字符串
  let queryString = Object.keys(params).map(key => key + '=' + encodeURIComponent(params[key])).join('&');

  // 判断原始 URL 中是否已经有查询参数
  if (url.indexOf('?') !== -1) {
    // 如果已经有查询参数，则在原有基础上添加新的参数对
    url += '&' + queryString;
  } else {
    // 如果没有查询参数，则直接添加一个问号和查询字符串
    url += '?' + queryString;
  }

  return url;
}

// 获取图片尺寸
export function getImgSize(url) {
  return new Promise((resolve, reject) => {
    let imgObj = new Image();
    imgObj.src = url;
    imgObj.onload = () => {
      resolve({
        width: imgObj.width,
        height: imgObj.height,
      });
    };
  });
}

export function getviodeSize(file) {
  return new Promise((resolve) => {
    let videoElement = document.createElement("video");
    videoElement.src = URL.createObjectURL(file);
    videoElement.addEventListener("loadedmetadata", function () {
      resolve({
        duration: videoElement.duration,
        height: videoElement.videoHeight,
        width: videoElement.videoWidth,
      });
    });
  });
}

// 显示文件类型图片
export function msgdataimg(val) {
  if (val.content.filename && val.msgtype == 15) {
    //获取最后一个.的位置
    let index = val.content.filename.lastIndexOf(".");
    //获取后缀
    let ext = val.content.filename.substr(index + 1);
    let img = "";
    if (ext == "doc" || ext == "docx") {
      img = "doc";
    } else if (
      ext == "jpg" ||
      ext == "png" ||
      ext == "gif" ||
      ext == "psd" ||
      ext == "jpeg"
    ) {
      img = "img";
    } else if (ext == "pdf") {
      img = "pdf";
    } else if (
      ext == "ppt" ||
      ext == "pptx" ||
      ext == "pps" ||
      ext == "ppsx" ||
      ext == "ppa" ||
      ext == "ppam"
    ) {
      img = "ppt";
    } else if (
      ext == "mp4" ||
      ext == "m4v" ||
      ext == "avi" ||
      ext == "dat" ||
      ext == "mkv" ||
      ext == "flv" ||
      ext == "rmvb" ||
      ext == "mpg" ||
      ext == "mpeg" ||
      ext == "rm"
    ) {
      img = "video";
    } else if (ext == "xls" || ext == "xlsx" || ext == "xlsm") {
      img = "xls";
    } else if (ext == "zip" || ext == "7z" || ext == "rar") {
      img = "zip";
    } else {
      img = "wenjian";
    }
    return img;
  }
}

// 转换文件大小
export function filedatasize(size) {
  let kb = 1024;
  let unit = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let i = Math.floor(Math.log(size) / Math.log(kb));
  // let unit = size < 1024 ? 'KB' : size < 1024*1024 ? 'MB'
  return (size / Math.pow(kb, i)).toPrecision(3) + " " + unit[i];
}

// 二进制转换成十进制
export function conversion(val1, val2, val3, val4) {
  let a = val1 ? "1" : "0";
  let b = val2 ? "1" : "0";
  let c = val3 ? "1" : "0";
  let d = val4 ? "1" : "0";
  let tims = a + b + c + d;
  return parseInt(tims, 2);
}

// 十进制转换成二进制
export function conversiontwo(val) {
  let jhg;
  let bkj;
  jhg = val.toString(2);
  bkj = jhg.split("");
  if (val < 8) {
    // 小于8时位数不足四位，往前补0
    let leng = 4 - bkj.length;
    for (let i = 0; i < leng; i++) {
      bkj.unshift("0");
    }
  }
  return bkj;
}

var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

export function base64Encode(e) {
  var t = "";
  var n, r, i, s, o, u, a;
  var f = 0;
  e = _utf8_encode(e);
  while (f < e.length) {
    n = e.charCodeAt(f++);
    r = e.charCodeAt(f++);
    i = e.charCodeAt(f++);
    s = n >> 2;
    o = (n & 3) << 4 | r >> 4;
    u = (r & 15) << 2 | i >> 6;
    a = i & 63;
    if (isNaN(r)) {
      u = a = 64
    } else if (isNaN(i)) {
      a = 64
    }
    t = t + _keyStr.charAt(s) + _keyStr.charAt(o)
      + _keyStr.charAt(u) + _keyStr.charAt(a)
  }
  return t
}

export function base64Decode(e) {
  var t = "";
  var n, r, i;
  var s, o, u, a;
  var f = 0;
  e = e.replace(/[^A-Za-z0-9+/=]/g, "");
  while (f < e.length) {
    s = _keyStr.indexOf(e.charAt(f++));
    o = _keyStr.indexOf(e.charAt(f++));
    u = _keyStr.indexOf(e.charAt(f++));
    a = _keyStr.indexOf(e.charAt(f++));
    n = s << 2 | o >> 4;
    r = (o & 15) << 4 | u >> 2;
    i = (u & 3) << 6 | a;
    t = t + String.fromCharCode(n);
    if (u != 64) {
      t = t + String.fromCharCode(r)
    }
    if (a != 64) {
      t = t + String.fromCharCode(i)
    }
  }
  t = _utf8_decode(t);
  return t
}

function _utf8_encode(e) {
  e = e.replace(/rn/g, "n");
  var t = "";
  for (var n = 0; n < e.length; n++) {
    var r = e.charCodeAt(n);
    if (r < 128) {
      t += String.fromCharCode(r)
    } else if (r > 127 && r < 2048) {
      t += String.fromCharCode(r >> 6 | 192);
      t += String.fromCharCode(r & 63 | 128)
    } else {
      t += String.fromCharCode(r >> 12 | 224);
      t += String.fromCharCode(r >> 6 & 63 | 128);
      t += String.fromCharCode(r & 63 | 128)
    }
  }
  return t
}

function _utf8_decode(e) {
  var t = "";
  var n = 0;
  var r = 0;
  var c2 = 0;
  var c3 = 0;
  while (n < e.length) {
    r = e.charCodeAt(n);
    if (r < 128) {
      t += String.fromCharCode(r);
      n++
    } else if (r > 191 && r < 224) {
      c2 = e.charCodeAt(n + 1);
      t += String.fromCharCode((r & 31) << 6 | c2 & 63);
      n += 2
    } else {
      c2 = e.charCodeAt(n + 1);
      c3 = e.charCodeAt(n + 2);
      t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3
        & 63);
      n += 3
    }
  }
  return t
}

export function deviceHash(str: string): number {
  let hash = 0;
  const prime = 31; // 选择一个质数作为乘法因子 
  for (let i = 0; i < str.length; i++) {
    hash = (hash * prime + str.charCodeAt(i)) % Number.MAX_SAFE_INTEGER;
  }
  return hash;
}

export function getFreeIdIndex() {
  return deviceHash(deviceid("deviceid"));
}

// 检查启动天数并打点
export function checkLoginEvent() {
  let storage = localStorage;
  let firstTimeStr = storage.getItem('FIRST_LAUNCH_TIME');
  const now = Date.now();
  if (firstTimeStr && firstTimeStr != "") { // 非首次启动
    const firstTime = Number(firstTimeStr);
    const deltaTime = now - firstTime;
    const hour = 1000 * 60 * 60;
    const isLaunchDays3 = !!storage.getItem('FIRST_LAUNCH_DAYS_3')
    if (!isLaunchDays3 && deltaTime > 48 * hour && deltaTime <= 72 * hour) {
      fbqEvent('trackCustom', 'Launch3Days');
      storage.setItem('FIRST_LAUNCH_DAYS_3', 'true');
    }
    const isLaunchDays7 = !!storage.getItem('FIRST_LAUNCH_DAYS_7')
    if (!isLaunchDays7 && deltaTime > 168 * hour && deltaTime <= 192 * hour) {
      fbqEvent('trackCustom', 'Launch7Days');
      storage.setItem('FIRST_LAUNCH_DAYS_7', 'true');
    }
  } else { // 首次启动
    storage.setItem('FIRST_LAUNCH_TIME', '' + now);
  }


  console.log('scq_view_30s');

  // 检测浏览页面时间
  const isView30s = !!storage.getItem('scq_view_30s');
  if (!isView30s) {
    setTimeout(() => {
      scqEvent('view_30s');
      storage.setItem('scq_view_30s', 'true');
    }, 30 * 1000);
  }

  const isView5s = !!storage.getItem('scq_view_5s');
  if (!isView5s) {
    setTimeout(() => {
      scqEvent('view_5s');
      storage.setItem('scq_view_5s', 'true');
    }, 5 * 1000);
  }
}

// 检查首次进入房间并打点
export function checkFirstEnterRoom() {
  const enterRoomSuccess = localStorage.getItem('enterRoomSuccess');
  if (!enterRoomSuccess) {
    fbqEvent('trackCustom', 'EnterRoomToday');
    ttqEvent('EnterRoomToday');
    scqEvent('initiate_live_new');
    // 更新最后一次启动日期
    localStorage.setItem('enterRoomSuccess', 'true');
  }
}

export function formatNewsTime(
  ts: number | string,
  options?: { now?: number }
): string {
  if (ts === null || ts === undefined || (ts as any) === "") return "-";

  const n = Number(ts);
  if (!isFinite(n)) return "-";

  // < 1e12 视为秒级，转毫秒
  const ms = n < 1e12 ? n * 1000 : n;

  const d = new Date(ms);
  if (isNaN(d.getTime())) return "-";

  const y = d.getFullYear();
  const MM = String(d.getMonth() + 1).padStart(2, "0");
  const DD = String(d.getDate()).padStart(2, "0");
  const HH = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");

  return `${y}-${MM}-${DD} ${HH}:${mm}`;
}


// export function formatNewsTime(
//   ts: number | string,
//   options?: { now?: number }
// ): string {
//   if (ts === null || ts === undefined || (ts as any) === "") return "-";

//   var n = Number(ts);
//   if (!isFinite(n)) return "-";

//   // < 1e12 视为秒级，转毫秒
//   var ms = n < 1e12 ? n * 1000 : n;

//   var now = options && typeof options.now === "number" ? options.now : Date.now();
//   var diffSec = Math.floor((now - ms) / 1000);

//   // if (diffSec < 0 && Math.abs(diffSec) < 60) return "刚刚";
//   // if (diffSec >= 0 && diffSec < 60) return "刚刚";

//   // if (diffSec < 3600) {
//   //   var m = Math.max(1, Math.floor(diffSec / 60));
//   //   return m + "分钟前";
//   // }

//   // if (diffSec < 86400) {
//   //   var h = Math.max(1, Math.floor(diffSec / 3600));
//   //   return h + "小时前";
//   // }

//   var d = new Date(ms);
//   if (isNaN(d.getTime())) return "-";
//   var y = d.getFullYear();
//   var MM = ("0" + (d.getMonth() + 1)).slice(-2);
//   var DD = ("0" + d.getDate()).slice(-2);
//   return y + "-" + MM + "-" + DD + "-";
// }
